module.exports = __webpack_public_path__ + "img/loading.3d13db6b.jpg";